import React from 'react'
import PropTypes from 'prop-types'
// import Script from 'react-load-script'

import { APP_ID } from 'config'
import api from 'lib/api'
import StubScript from 'components/facebook/StubScript'

const SDK_URL = '//connect.facebook.net/en_US/messenger.Extensions.js'

/**
 * The SdkLoader loads the Facebook Messenger Extensions SDK asynchronously.
 * It reports the loading state and returns the threadContext from facebook.
 *
 * The SDK will only be loaded in a production-like environment. In other
 * environments the loading behavior of the SDK will be simulated.
 */
export default class SdkLoader extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    /** Callback Function when user data is available. */
    onAuthorized: PropTypes.func,
    /** Callback Function when error happened. */
    onError: PropTypes.func
  }

  static defaultProps = {
    onAuthorized: () => {},
    onError: () => {}
  }

  handleSuccess = threadContext => {
    this.props.onAuthorized(threadContext)
  }

  handleError = error => {
    this.props.onError(error)
  }

  handleInit = () => {
    api.MessengerExtensions.getContext(APP_ID)
      .then(this.handleSuccess)
      .catch(this.handleError)
  }

  componentDidMount() {
    // The MessengerExtensions SDK invokes `window.extAsyncInit` when the
    // SDK is loaded.
    window.extAsyncInit = () => {
      this.handleInit()
    }
  }

  render() {
    // Use the stub `StubScript` in non-prod environments, because we can only
    // use the Messenger Extensions SDK in production. `StubScript` calls
    // `window.extAsyncInit()` to simulate the behavior of the SDK.
    // const ScriptLoader = process.env.NODE_ENV === 'production' ? Script : StubScript

    // NOTE: We patch out the sdk-loader due an ongoing issue with Facebook Messenger SDK
    const ScriptLoader = process.env.NODE_ENV === 'production' ? StubScript : StubScript

    return (
      <React.Fragment>
        <ScriptLoader
          url={SDK_URL}
          attributes={{ id: 'Messenger' }}
          onError={this.handleError}
          onLoad={() => {}}
        />
        {this.props.children}
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/facebook/SdkLoader.js